<template>
  <div>
    <popup-add-stock-product
      v-if="productPackage"
      ref="popupAddProduct"
      :alreadySelectedProducts="productPackage.stockIngredients"
      :selectableStockProducts="stockProducts"
      @onSelected="onSelectedNewStockProduct"
    />

    <RightSidebar :isActive.sync="isActive" size="large">
      <template #header>
        <img width="40" :src="ProductIcon" class="mr-4" />
        <div>
          <h4>{{ isNewProduct ? "New " : "" }}Package</h4>
          <small v-if="productPackage"> {{ productPackage.id }} • {{ productPackage.name }} </small>
        </div>
      </template>

      <template #content>
        <Loading v-if="isLoading" />
        <div v-else>
          <section class="px-6 grid grid-cols-4 gap-x-8 mt-4">
            <SidebarItem label="Package name" class="col-span-2">
              <vs-input class="w-full" v-model="productPackage.name" />
            </SidebarItem>

            <!-- <SidebarItem label="Package price (0 is free)">
              <NumberInput v-model="productPackage.price" unit="DKK" />
            </SidebarItem> -->

            <!-- <SidebarItem label="Description" class="col-span-2 row-span-2">
              <vs-textarea
                class="w-full h-full"
                v-model="product.description"
              />
            </SidebarItem> -->
          </section>

          <h3 class="ml-4 mb-2 mt-2">Choosable ingredients</h3>
          <div class="mx-6 table-primary-bg data-list-list-view max-w-md compact-table">
            <vs-table :data="productPackage.stockIngredients">
              <template slot="thead">
                <vs-th sort-key="number">Product</vs-th>
                <vs-th sort-key="amount">Amount</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{ data }">
                <draggable
                  tag="tbody"
                  ghost-class="moving-card"
                  filter=".action-button"
                  :list="productPackage.stockIngredients"
                  :animation="200"
                >
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data" class="cursor-default">
                    <vs-td class="pl-0">
                      <div class="product-name font-medium truncate flex flex-row items-center">
                        <div class="material-icons text-grey mr-1 cursor-move">drag_indicator</div>
                        <!-- <img width="40" :src="ProductIcon" /> -->
                        <div class="flex flex-col">
                          <div class="whitespace-nowrap overflow-hidden truncate" style="width: 206px">
                            {{ tr.stockProduct.name }}
                          </div>
                          <div class="flex items-center">
                            <div class="text-sm text-grey">
                              {{ tr.stockProduct.number }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td>
                      <NumberSelectInput
                        v-model="tr.amount"
                        :unit.sync="tr.productUnit"
                        :units="units"
                        style="width: 142px"
                        :compact="true"
                        @change="onUpdateIngredientAmount(tr)"
                      />
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        icon="TrashIcon"
                        class="cursor-pointer"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        @click.stop="removeItem(tr)"
                      />
                    </vs-td>
                  </vs-tr>
                </draggable>
              </template>
            </vs-table>

            <div class="flex justify-end mt-2 mr-1">
              <vs-button type="border" @click="$refs.popupAddProduct.show()">
                <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
                <span class="ml-1">Add stock product</span>
              </vs-button>
              <!-- <vs-button
              type="border"
              class="ml-4"
              @click="$refs.popupAddCategory.show()"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />
              <span class="ml-1">Add category</span>
            </vs-button> -->
            </div>
          </div>

          <!-- <h3 class="ml-4 mb-2 mt-8">Profit margin</h3> -->
          <!-- Spacer -->
          <div class="h-24"></div>
        </div>
      </template>

      <template #footer>
        <!-- <section class="grid grid-cols-5 gap-x-8 mb-2" v-if="productPackage">
          <SidebarItem label="Maximum total cost">
            <NumberInput
              v-model="pricingMetrics.cost"
              unit="DKK"
              :disabled="true"
            />
          </SidebarItem>

          <SidebarItem label="Price">
            <NumberInput
              v-model="pricingMetrics.price"
              unit="DKK"
              :disabled="true"
            />
          </SidebarItem>

          <SidebarItem label="Minimum profit">
            <NumberInput
              v-model="pricingMetrics.profit"
              unit="DKK"
              :disabled="true"
            />
          </SidebarItem>

          <SidebarItem label="Highest profit margin">
            <NumberInput
              v-model="pricingMetrics.profitMargin"
              unit="%"
              :disabled="true"
            />
          </SidebarItem>

          <SidebarItem label="Worst COGS">
            <NumberInput
              v-model="pricingMetrics.cogs"
              unit="%"
              :disabled="true"
            />
          </SidebarItem>
        </section> -->

        <vs-button @click="submitData" :disabled="!isFormValid">{{ isNewProduct ? "Create" : "Save" }}</vs-button>
        <vs-button type="border" color="danger" class="ml-6" @click="isActive = false">Cancel</vs-button>
      </template>
    </RightSidebar>
  </div>
</template>

<script>
import ProductIcon from "@/assets/images/product-icon.png";
import moment from "moment";
import { mapGetters } from "vuex";
import VenueSelector from "@/components/VenueSelector.vue";
import RightSidebar from "@/components/Custom/RightSidebar.vue";
import SidebarItem from "@/components/Custom/SidebarItem.vue";
import NumberSelectInput from "@/components/Custom/NumberSelectInput.vue";
import NumberInput from "@/components/Custom/NumberInput.vue";
import PopupAddStockProduct from "./PopupAddStockProduct.vue";
import { calculateCogs } from "@/utils/posUtils.js";
import _ from "lodash";
import Draggable from "vuedraggable";

export default {
  components: {
    VenueSelector,
    RightSidebar,
    SidebarItem,
    NumberSelectInput,
    NumberInput,
    PopupAddStockProduct,
    Draggable
  },
  data() {
    return {
      ProductIcon,
      calculateCogs,

      isActive: false,
      isLoading: true,

      isNewProduct: false,
      productPackage: null
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeCountry: "venues/activeCountry",
      countries: "pos/countries/countries",

      stockProducts: "pos/stockProducts/stockProducts",
      units: "pos/countrySettings/units"
    }),
    isFormValid() {
      return true; // TODO
    },
    pricingMetrics() {
      const unitMatrix = {
        ml: 0.001,
        cl: 0.01,
        dl: 0.1,
        l: 1
      };

      const measureableUnitsOfMeasure = ["pcs", "btl", "can", "unit", "glass", "bag"]; // TODO: Get from API

      // Total cost, total price, total profit, profit margin, cogs
      // Find the ingredient with the highest cost
      const highestPossibleCost = _.chain(this.productPackage.stockIngredients)
        .map(i => {
          if (measureableUnitsOfMeasure.includes(i.productUnit)) {
            return i.stockProduct.unitPrice * i.amount;
          } else {
            const unitInLiters = unitMatrix[i.productUnit];
            return (i.stockProduct.unitPrice / i.stockProduct.productUnitInLiters) * i.amount * unitInLiters;
          }
        })
        .max()
        .value();

      const cost = (highestPossibleCost || 0).toFixed(2);
      const price = this.productPackage.price;
      const profit = (price - highestPossibleCost).toFixed(2);
      const profitMargin = ((profit / price) * 100).toFixed(2);
      const cogs = ((highestPossibleCost / price) * 100).toFixed(2);

      return {
        cost,
        price,
        profit,
        profitMargin,
        cogs
      };
    }
  },
  methods: {
    async show(productPackageId) {
      this.isNewProduct = false;
      this.isActive = true;
      this.isLoading = true;

      this.productPackage = await this.$store.dispatch("pos/packages/getPackage", productPackageId);
      console.log("ProductPackage:", this.productPackage);
      await this.loadExternalData();

      this.isLoading = false;
    },
    async showEmptyPackage() {
      this.isNewProduct = true;

      this.productPackage = {
        countryId: "dk", // TODO
        name: "",
        description: "",
        price: 0,
        stockIngredients: [],
        createdBy: null,
        createdAt: null
      };

      this.isActive = true;
      this.isLoading = true;
      await this.loadExternalData();
      this.isLoading = false;
    },

    async loadExternalData() {
      await Promise.all([
        // this.$store.dispatch("pos/countries/getCountries"),
        this.$store.dispatch("pos/countrySettings/getCountrySettings"),
        this.$store.dispatch("pos/stockProducts/getStockProducts")
      ]);
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },

    // onUpdateIngredientAmount(ingredient) {
    //   // Find matching default pricing if exists
    //   console.log(
    //     ingredient.amount,
    //     ingredient.productUnit,
    //     ingredient.stockProduct.defaultPricings
    //   );
    //   const defaultPrice = ingredient.stockProduct.defaultPricings.find(
    //     (p) =>
    //       p.amount == ingredient.amount &&
    //       p.productUnit == ingredient.productUnit
    //   );

    //   if (defaultPrice) {
    //     const newPrice = defaultPrice.price;

    //     if (ingredient.priceMin != newPrice) {
    //       ingredient.priceMin = newPrice;

    //       // Toast notification
    //       this.$vs.notify({
    //         title: "Price automatically updated",
    //         text: `The minimum price for ingredient ${ingredient.stockProduct.name} was set to the default price: ${newPrice} DKK`,
    //         color: "green",
    //         iconPack: "feather",
    //         icon: "icon-alert-circle",
    //         time: 3000,
    //       });
    //     }
    //   }
    // },

    async submitData() {
      console.log("Submitting DTO", this.productPackage);
      let newCreatedPackageResponse = null;

      try {
        if (this.isNewProduct) {
          newCreatedPackageResponse = await this.$store.dispatch("pos/packages/createPackage", this.productPackage);
          console.log("New created package", newCreatedPackageResponse);
        } else {
          await this.$store.dispatch("pos/packages/updatePackage", {
            packageId: this.productPackage.id,
            packageDto: this.productPackage
          });
        }

        this.productPackage = null;
        this.isActive = false;
        this.isLoading = true;

        console.log("New created package", newCreatedPackageResponse);

        // If we just created a new product. Show the sidebar again with the product
        if (newCreatedPackageResponse) {
          this.show(newCreatedPackageResponse);
        }

        this.$store.dispatch("pos/packages/getPackages");

        this.$vs.notify({
          title: "Success",
          text: `Successfully ${this.isNewProduct ? "created new" : "updated"} package`
        });
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          color: "danger",
          text: `Failed to ${this.isNewProduct ? "create" : "update"} package: ${error}`
        });

        this.isLoading = false;
      }
    },

    onSelectedNewStockProduct(stockProduct) {
      console.log("Selected new stock product", stockProduct);

      const ingredient = {
        stockProductId: stockProduct.id,
        amount: 1,
        productUnit: stockProduct.productUnit,
        stockProduct
      };

      // Take the first default pricing of the stockProduct, if it exists
      // if (stockProduct.defaultPricings.length > 0) {
      //   const defaultPricing = stockProduct.defaultPricings[0];
      //   ingredient.amount = defaultPricing.amount;
      //   ingredient.priceMin = defaultPricing.price;
      //   ingredient.productUnit = defaultPricing.productUnit;
      // }

      this.productPackage.stockIngredients.push(ingredient);
    },

    removeItem(item) {
      console.log("Want to remove item", item);
      this.productPackage.stockIngredients = this.productPackage.stockIngredients.filter(i => i.stockProductId !== item.stockProductId);
    }
  }
};
</script>

<style scoped lang="scss">
.recipe-table {
  :deep(.vs-table--thead tr) {
    color: white;
  }

  :deep(.vs-con-tbody) {
    background-color: rgba(var(--vs-primary)) !important;
    border-radius: 8px;
  }
}

.custom-color-picker {
  appearance: none;
  border: none;
  background-color: transparent;

  &::-webkit-color-swatch {
    border: none;
    border-radius: 12px;
    box-shadow: 2px 4px 12px 0 var(--color-picker-color);
  }
  &::-webkit-color-swatch-wrapper {
    padding: 16px;
  }
}
</style>